import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function loginData(data) {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/auth`,
      data,
    });

    localStorage.setItem("token", result.data.token);
    localStorage.setItem(
      "role",
      JSON.stringify(result.data.user.permission_id)
    );
    localStorage.setItem("user", JSON.stringify(result.data.user.id));
    localStorage.setItem("userName", JSON.stringify(result.data.user.name));

    return result;
  } catch (error) {
    if (error.response.data === "error: Email or Password are wrong") {
      return alert("Usuário ou senha incorreto. Tente novamente.");
    }
    alert("Servidor indisponível, favor tente novamente.");
    return error;
  }
}

export async function isTokenValid(token) {
  try {
    const result = await axios({
      method: "POST",
      url: `${BASE_API_URL}/validate`,
      data: {
        token,
      },
    });

    return result;
  } catch (error) {
    return error.response;
  }
}
